import { HoldEvent } from '@wui/jssip/lib/RTCSession'
import { defineStore } from 'pinia'
import { ref } from 'vue'

type State = Map<string, { local: boolean, remote: boolean }>

export const useHoldStore = defineStore('hold', () => {
  const holdStates = ref<State>(new Map())

  const setState = (sessionId: string, originator: HoldEvent['originator'], value: boolean) => {
    if (!holdStates.value.has(sessionId)) {
      holdStates.value.set(sessionId, {
        local: false,
        remote: false,
      })
    }

    const state = holdStates.value.get(sessionId)
    if (state) {
      if (originator === 'local') {
        state.local = value
      } else if (originator === 'remote') {
        state.remote = value
      }
    }
  }

  const removeState = (sessionId: string) => {
    holdStates.value.delete(sessionId)
  }

  const getIsRemoteHold = (sessionId: string) => !!holdStates.value.get(sessionId)?.remote

  const getIsLocalHold = (sessionId: string) => holdStates.value.get(sessionId)?.local

  return {
    setState,
    removeState,
    getIsRemoteHold,
    getIsLocalHold,
  }
})
